import { walkInDiscountAvailabilityStrategy } from "./walkInDiscountAvailabilityStrategy";
import type { NonEmptyArray } from "../../../types";
import { hasDiscountAvailability } from "../../../utils/discountAvailability";
import hasFetchedAvailability from "../../../utils/store/hasFetchedAvailability";
import { RestaurantDetailsById } from "../../restaurants/byId";
import { type Time } from "../../times/model";
import {
  type ByRestaurantId,
  type DiscountAvailabilityById,
} from "../../types";

/**
 * Walk-in list visibility. Same date/availability skeleton as
 * `shouldShowDiscountSection`, but never applies FT `regularOnly` /
 * `hasLastTable` / First Table session gates — walk-in inventory is slot-level
 * (`walkInsEnabled`). Removable with `model/walkIn`.
 */
export default function shouldShowWalkInDiscountSection(
  restaurantsById: RestaurantDetailsById,
  discountAvailabilityById: DiscountAvailabilityById,
  date: string,
  timesIsSet: boolean,
  startTime: Time,
  endTime: Time,
  discountDatesToShowById: ByRestaurantId<NonEmptyArray<string>>,
  restaurantId: number,
  isSingleMode: boolean,
  loading: boolean,
  skipInitialFirebaseFetch: boolean,
  people?: number,
) {
  const restaurant = restaurantsById[restaurantId];

  if (!restaurant) {
    return false;
  }

  if (isSingleMode) {
    return true;
  }

  const hasAvailability = hasDiscountAvailability(
    discountAvailabilityById,
    date,
    restaurantId,
    timesIsSet,
    startTime,
    endTime,
    people,
    undefined,
    walkInDiscountAvailabilityStrategy,
  );
  const restaurantAvailability = discountAvailabilityById[restaurantId];
  const hasFetched = hasFetchedAvailability(date, restaurantAvailability);
  const isDiscountFetchPending =
    loading || (skipInitialFirebaseFetch && !hasFetched);

  if (timesIsSet) {
    return hasAvailability || (!hasFetched && isDiscountFetchPending);
  }

  return true;
}
